import { render, staticRenderFns } from "./BuyTapPro.vue?vue&type=template&id=16c44e80&scoped=true&"
import script from "./BuyTapPro.vue?vue&type=script&lang=js&"
export * from "./BuyTapPro.vue?vue&type=script&lang=js&"
import style0 from "./BuyTapPro.vue?vue&type=style&index=0&id=16c44e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c44e80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16c44e80')) {
      api.createRecord('16c44e80', component.options)
    } else {
      api.reload('16c44e80', component.options)
    }
    module.hot.accept("./BuyTapPro.vue?vue&type=template&id=16c44e80&scoped=true&", function () {
      api.rerender('16c44e80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_price_versions/components/Buy/BuyTapPro.vue"
export default component.exports